// 接口名定义
// const schedulingUrl = '/business/projectScheduling/'
const url = '/business/yhWorker/'
const urlJg = '/business/jgWorker/'
const urlTeamJg = '/business/jgTeamManagement/'

export default {
  insertProjectWorker: '/business/projectWorker/insertProjectWorker',
  updateProjectWorker: '/business/projectWorker/updateProjectWorker',
  deleteProjectWorker: '/business/projectWorker/deleteProjectWorker',
  selectProjectWorkerByWorkerId: '/business/projectWorker/selectProjectWorkerByWorkerId',
  selectProjectWorkerByList: '/business/projectWorker/selectProjectWorkerByList',
  selectProjectWorkerByPage: '/business/projectWorker/selectProjectWorkerByPage',
  // 班组
  insertProjectUserTeam: '/business/projectUserTeam/insertProjectUserTeam',
  updateProjectUserTeam: '/business/projectUserTeam/updateProjectUserTeam',
  deleteProjectUserTeam: '/business/projectUserTeam/deleteProjectUserTeam',
  selectProjectUserTeamByList: '/business/projectUserTeam/selectProjectUserTeamByList',
  countBoundDevice: '/business/projectWorker/countBoundDevice',
  // 排班
  // selectProjectSchedulingByPage: schedulingUrl + 'selectProjectSchedulingByPage',
  // insertAllProjectScheduling: schedulingUrl + 'insertAllProjectScheduling',
  // updateProjectScheduling: schedulingUrl + 'updateProjectScheduling',
  // deleteDataProjectScheduling: schedulingUrl + 'deleteDataProjectScheduling',
  // selectProjectSchedulingByList: schedulingUrl + 'selectProjectSchedulingByList',
  // selectWorkerList: schedulingUrl + 'selectWorkerList',
  // selectWorkTimeListByProjectId: schedulingUrl + 'selectWorkTimeListByProjectId',
  // selectProjectSchedulingById: schedulingUrl + 'selectProjectSchedulingById',
  // selectSchedulingCalendarPage: schedulingUrl + 'selectSchedulingCalendarPage',
  // 在岗监测
  selectWorkerOnWorkjPage: '/business/workCard/selectWorkerOnWorkjPage',
  selectOffWorkCardPage: '/business/workCard/selectOffWorkCardPage',
  exportWorkerOnWork: '/business/workCard/exportWorkerOnWork',
  exportOffWorkCard: '/business/workCard/exportOffWorkCard',

  // 云养护
  selectYhWorkerByPage: '/business/jgWorker/selectYhWorkerByPage',
  // OCR身份证识别
  ocrCard: '/business/jgWorker/ocrCard',
  // 人脸照片校验
  detectFaceImg: '/business/jgWorker/detectFaceImg',
  insertYhWorker: urlJg + 'insertYhWorker',
  updateYhWorkerJg: urlJg + 'updateYhWorker',
  updateYhWorker: urlJg + 'updateYhWorker',
  deleteYhWorker: urlJg + 'deleteYhWorker',
  selectYhWorkerByWorkerId: url + 'selectYhWorkerByWorkerId',
  selectYhWorkerByWorkerIdJg: urlJg + 'selectYhWorkerByWorkerId',
  importProjectWorker: '/business/jgWorker/importProjectWorker',
  selectYhWorkerList: urlJg + 'selectYhWorkerList',
  updateYhTeam: urlTeamJg + 'updateYhTeam',
  selectWorkerSum: '/business/jgTeamManagement/selectWorkerSum'
}
